import { EventEmitter } from 'eventemitter3';
import Request from './request';

export default class UsageService {

	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return this._instance = new UsageService();
	}

	constructor() {
		this.events = new EventEmitter;
	}

	getUsage() {
		return Request.instance().get('/console/v1/billing/invoice');
	}

	getVirtualCash() {
		return Request.instance().get('/console/v1/virtual/cash');
	}
}